import '.ak{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ha{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.aj{justify-content:center;}.ssr-plugin'
import '.aq{align-items:flex-start;}.ssr-plugin'
import '.ek{padding:2rem;}.ssr-plugin'
import '.e5{background:var(--palette-white);}.ssr-plugin'
import '.bv{overflow:hidden;}.ssr-plugin'
import '.b8{position:absolute;}.ssr-plugin'
import '.jw{top:50%;}.ssr-plugin'
import '.jx{right:1rem;}.ssr-plugin'
import '.jy{transform:translateY(-50%);}.ssr-plugin'
import '.jz{width:120px;}.ssr-plugin'
import '.k0{height:120px;}.ssr-plugin'
import '.k1{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.h3{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.k2{max-width:calc(100% - 140px);}.ssr-plugin'
import '.k3{font-size:4rem;}.ssr-plugin'
import '.ci{font-weight:700;}.ssr-plugin'
import '.k4{line-height:100%;}.ssr-plugin'
import '.hj{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ak l ha a b aj aq ek e5 bv"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b8 jw jx jy jz k0 k1 a r aj"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ak h3 a b aq s k2"
      >
        <div className="k3 ci k4 hj a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
